var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 15,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26829 4.60605L6.83986 10.4092H5.25549L4.06046 5.77803C3.9879 5.49278 3.92482 5.38827 3.70417 5.26809C3.34392 5.07235 2.74901 4.88869 2.22559 4.77471L2.26114 4.60605H4.81148C5.13657 4.60605 5.42881 4.8228 5.50262 5.19775L6.13375 8.55577L7.69358 4.60595L9.26829 4.60605ZM15.4761 8.51455C15.4825 6.98291 13.3616 6.89853 13.3761 6.21433C13.3807 6.0061 13.5786 5.78471 14.0119 5.7282C14.2267 5.70004 14.8184 5.67856 15.4895 5.9879L15.7528 4.75729C15.3922 4.62618 14.9281 4.5 14.3508 4.5C12.8693 4.5 11.8267 5.2888 11.818 6.4183C11.8084 7.25374 12.5621 7.71994 13.13 7.99755C13.7142 8.28183 13.9102 8.46452 13.908 8.71881C13.9038 9.10808 13.442 9.27993 13.0105 9.28671C12.2571 9.29832 11.82 9.08254 11.4715 8.92027L11.1999 10.1916C11.5501 10.3525 12.1965 10.4929 12.8666 10.5C14.4412 10.5 15.4713 9.72097 15.4761 8.51455ZM19.3881 10.4092H20.7744L19.5644 4.60605H18.2849C17.9972 4.60605 17.7545 4.77384 17.6471 5.0318L15.398 10.4092H16.9718L17.2842 9.54245H19.2072L19.3881 10.4092ZM17.7158 8.35305L18.5047 6.17417L18.9587 8.35305H17.7158ZM11.4098 4.60605L10.1704 10.4092H8.67164L9.9115 4.60605H11.4098Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card_visa.4ad9f46871d9d10c6a774f7723270d20.svg";
export { ForwardRef as ReactComponent };